import { Injectable, inject } from '@angular/core';
import { FeatureGateService } from '@app/shared/services/featuregate.service';
import { AdditionalServiceVoice } from '../models/additional-service-voice.model';

@Injectable({
  providedIn: 'root',
})
export class IncludedServicesService {
  private isNettvernLaunched = inject(FeatureGateService).isFeatureEnabled('featureNettvernPostlaunch');

  isIncluded(service: AdditionalServiceVoice): boolean {
    return this.isNettvernLaunched && !!service?.isNettvern;
  }
}
